const dropDownOptions: Array<{ print: JSX.Element | string; data: string }> = [
  {
    print: '사용자지정',
    data: 'default',
  },
  {
    print: '신규순',
    data: 'latest',
  },
  {
    print: '오래된순',
    data: 'oldest',
  },
  {
    print: '중요도',
    data: 'priority',
  },
  {
    print: '마감임박',
    data: 'due',
  },
];

export { dropDownOptions };
